import React from 'react'
import { connect } from 'react-redux'
import {
  createStyles,
  Fade,
  Grid,
  makeStyles,
  Typography,
} from '@material-ui/core'
import clsx from 'clsx'
import Button from '../Button/Button'
import Commitment from '../Commitment/Commitment'
import { useAddress } from '../../hooks/useAddress'
import AddressForm from '../Information/AddressForm'
import { prismicText } from '../Global/CMSText'

const useStyles = makeStyles((theme) =>
  createStyles({
    loginFormCard: {
      background: theme.palette.common.white,
      padding: theme.spacing(2),
      [theme.breakpoints.down('md')]: {
        width: '100%',
      },
    },
    invite: {
      margin: theme.spacing(4, 0),
    },
    form: {
      width: '70%',
      margin: 'auto',
    },
    smallSpace: {
      marginBottom: theme.spacing(2),
    },
    underline: {
      textDecoration: 'underline',
      cursor: 'pointer',
    },
    marginBottom: {
      marginBottom: theme.spacing(2),
    },
  })
)

type Tprops = {
  text: any
  userFirstName: string
  switchForm: any
  onSubmit: any
  t?: any
  hasAddress: any
  user?: any
  isTakeBack?: boolean
  funnel?: any
}

const mapStateToProps = (state) => ({
  user: state.user,
})

const ConnectedForm = ({
  switchForm,
  text,
  userFirstName,
  onSubmit,
  user,
  t,
  hasAddress,
  isTakeBack = false,
  funnel,
}: Tprops) => {
  const classes = useStyles()
  const { address, resetInputAddress } = useAddress('shipping')

  const commitmentOnLogin = text?.is_displayed_on_login

  const noAddress =
    hasAddress?.address !== undefined &&
    Object.keys(hasAddress.address).length === 0 &&
    hasAddress.address.constructor === Object

  const isSubscription =
    process.env.STORE_TYPE === 'subscription' ||
    process.env.STORE_TYPE === 'classic_subscription'

  const submitConnectedData = () => {
    if (noAddress) {
      onSubmit(address.payload)
    } else {
      onSubmit(user?.user?.address)
    }
    resetInputAddress()
  }

  return (
    <Fade in>
      <div className={classes.loginFormCard}>
        {noAddress && (
          <>
            <Grid container spacing={1} className={classes.marginBottom}>
              <Grid item xs={12}>
                <Typography variant={'h4'} align="center">
                  {userFirstName}
                  {', '}
                  {prismicText(
                    text?.address_required,
                    t('texts:account:address_required')
                  )}
                </Typography>
              </Grid>
            </Grid>
            <AddressForm
              account={isTakeBack}
              addressType="shipping"
              hideAdditionalAddress={funnel?.data?.hide_additional_address}
            />
          </>
        )}
        <Grid container justify="center">
          {noAddress && (
            <Button
              variant={'contained'}
              color={'primary'}
              className={clsx(classes.smallSpace, 'connected-form__button')}
              onClick={submitConnectedData}
              data-testid={'Buttoncontinue'}
              disabled={!address.isValid}
            >
              {t('texts:account:continue')}
            </Button>
          )}
        </Grid>
        {!isSubscription && !isTakeBack && text?.is_display_guest_link && (
          <div className={classes.invite}>
            <Typography
              variant={'body2'}
              color={'textSecondary'}
              align="center"
              className={classes.underline}
              onClick={() => switchForm(2)}
            >
              {prismicText(text?.guest_link, t('texts:account:guest_link'))}
            </Typography>
          </div>
        )}
        {!isTakeBack && commitmentOnLogin && (
          <div className={'commitment__area'}>
            <Commitment
              icon={
                text?.protected_data_image?.url
                  ? text?.protected_data_image?.url
                  : null
              }
              title={prismicText(
                text?.title_data,
                t('texts:account:title_data')
              )}
              desc={prismicText(text?.text_data, t('texts:account:text_data'))}
              center={false}
            />
          </div>
        )}
      </div>
    </Fade>
  )
}

export default connect(mapStateToProps)(ConnectedForm)
